import { PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
import { ExternalToolLinkParams, ExternalToolLinkResponse } from '@repo/shared-types'

const initialState: GenericOperationState<ExternalToolLinkResponse | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: externalToolLinkDataActions, reducer: externalToolLinkDataReducers } =
  createOperationSlice<
    ExternalToolLinkResponse | null,
    SliceCaseReducers<GenericOperationState<ExternalToolLinkResponse | null>>,
    ExternalToolLinkParams
  >({
    name: '@tools/externalTool/link',
    initialState,
    reducers: {
      getRequest(
        state: GenericOperationState<ExternalToolLinkResponse | null>,
        _action: PayloadAction<ExternalToolLinkParams>,
      ) {
        state.meta.fetchState = 'loading'
        state.meta.error = undefined
        state.error = false
        state.payload = null
      },
    },
  })
